import { getProfileKey } from '../../authentication/selectors';
import jobGroupActions from '../../entities/jobGroups/actions';
import { getJobGroupsIds } from './selectors';

export const TYPES = {
  LOAD_REQUEST: 'jobGroup/LOAD_REQUEST',
  LOAD_REQUEST_SUCCESS: 'jobGroup/LOAD_REQUEST_SUCCESS',
  LOAD_REQUEST_ERROR: 'jobGroup/LOAD_REQUEST_ERROR',
  CLEAR_STATE: 'jobGroup/CLEAR_STATE',
  UPDATE_FILTER_OPTIONS: 'jobGroup/UPDATE_FILTER_OPTIONS',
};

export const search = (options, isChangeInPagination = true, isClearPrevState = true) => async (dispatch, getState) => {
  dispatch({ type: TYPES.LOAD_REQUEST, payload: { page: options.page_current } });
  const profileKey = getProfileKey(getState());
  const groupIds = getJobGroupsIds(getState());
  try {
    const response = await dispatch(jobGroupActions.getAllJobGroups(options, profileKey));
    const { data: { content } } = response;
    const pagination = {
      pageNumber: response?.data?.page_current,
      pageSize: response?.data?.size,
      hasMore: response?.data?.total_pages > response?.data?.number + 1,
      totalElements: response?.data?.totalElements,
    };
    const prevIds = options.page_current === 1 ? [] : groupIds;
    const payload = {
      groupIds: [...new Set([...prevIds, ...content.map(jobGroup => jobGroup.id)])],
      isClearPrevState,
    };
    if (isChangeInPagination) {
      payload.pagination = pagination;
    }
    dispatch({ type: TYPES.LOAD_REQUEST_SUCCESS, payload });
    return response;
  } catch (error) {
    dispatch({ type: TYPES.LOAD_REQUEST_ERROR, payload: error });
    throw error;
  }
};

export const clearState = (dispatch) => {
  dispatch({ type: TYPES.CLEAR_STATE });
};

export const updateFilterOptions = options => (dispatch) => {
  dispatch({ type: TYPES.UPDATE_FILTER_OPTIONS, payload: options });
};

export default {
  TYPES,
  search,
  clearState,
  updateFilterOptions,
};
